<template>
  <div>
    <OperationsDeliveryOrders v-if="$getConstRole('ROLE_OPERATIONS') == role"></OperationsDeliveryOrders>
    <AdminDeliveryOrders v-if="$getConstRole('ROLE_ADMIN') == role"></AdminDeliveryOrders>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OperationsDeliveryOrders from '@/views/operations/DeliveryOrders.vue'
import AdminDeliveryOrders from '@/views/admin/dispatch/DeliveryOrders.vue'

export default {
  name: 'DeliveryOrders',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    OperationsDeliveryOrders,
    AdminDeliveryOrders
  },
};
</script>
